export default "__VITE_ASSET__DOhDFdTY__"